// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.box-api-info, .box-customer-card{
    width: 36em;
    height: 30em;
    border-radius: 2.6em;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 2.4em;
    font-size: 1em;
    box-shadow: 1px 1px 5px 1px var(--box-shadow-light);
    background: var(--white);
}

.box-customer-card{
    padding: 0px;
    margin: auto;
}

.container-loading-icon{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: relative;
} 

.button-card-box{
    border: none;
}

.box-api-info:hover, .box-customer-card:hover{
    transform: scale(1.05);
    transition: 0.3s;
    cursor: pointer;
}

.header-api-info, .body-api-info{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    gap: 2px;
}

.header-api-info .api-rulename{
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    width: 80%;
    margin: auto;
}

.header-api-info .api-rulename h3{
    font-size: 2.4em;
}

.header-api-info .api-id{
    font-weight: bold;
    font-size: 2.4em;
}

.body-api-info{
    padding: 1.4em 0;
    border-top: 1px solid var(--line-color-light);
    border-bottom: 1px solid var(--line-color-light);
    font-size: 2em;
}

.api-status-message{
    height: 2em;
    width: 82%;
    border-radius: 0.6em;
    line-height: 2em;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 1em;
    font-size: 1em;
}

.icon-inMessage{
  padding-bottom: 0.2em;
}`, "",{"version":3,"sources":["webpack://./src/pages/customerstatus/boxcard/style.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,cAAc;IACd,mDAAmD;IACnD,wBAAwB;AAC5B;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,QAAQ;AACZ;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,UAAU;IACV,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,6CAA6C;IAC7C,gDAAgD;IAChD,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,UAAU;IACV,oBAAoB;IACpB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,QAAQ;IACR,cAAc;AAClB;;AAEA;EACE,qBAAqB;AACvB","sourcesContent":[".box-api-info, .box-customer-card{\n    width: 36em;\n    height: 30em;\n    border-radius: 2.6em;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 2.4em;\n    font-size: 1em;\n    box-shadow: 1px 1px 5px 1px var(--box-shadow-light);\n    background: var(--white);\n}\n\n.box-customer-card{\n    padding: 0px;\n    margin: auto;\n}\n\n.container-loading-icon{\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    position: relative;\n} \n\n.button-card-box{\n    border: none;\n}\n\n.box-api-info:hover, .box-customer-card:hover{\n    transform: scale(1.05);\n    transition: 0.3s;\n    cursor: pointer;\n}\n\n.header-api-info, .body-api-info{\n    width: 100%;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    text-align: center;\n    gap: 2px;\n}\n\n.header-api-info .api-rulename{\n    white-space: normal;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    width: 80%;\n    margin: auto;\n}\n\n.header-api-info .api-rulename h3{\n    font-size: 2.4em;\n}\n\n.header-api-info .api-id{\n    font-weight: bold;\n    font-size: 2.4em;\n}\n\n.body-api-info{\n    padding: 1.4em 0;\n    border-top: 1px solid var(--line-color-light);\n    border-bottom: 1px solid var(--line-color-light);\n    font-size: 2em;\n}\n\n.api-status-message{\n    height: 2em;\n    width: 82%;\n    border-radius: 0.6em;\n    line-height: 2em;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    gap: 1em;\n    font-size: 1em;\n}\n\n.icon-inMessage{\n  padding-bottom: 0.2em;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
